import api_fetch from "../utils/api_fetch";
import { storageHandler } from '../utils/storage_handler';

const amexTransactions = {
    getTransactionById: async function(reference) {
        return (await api_fetch.get(`/v1/amex-transaction/${reference}`, {
            // Authorization: `Bearer ${storageHandler.localStorageGet('token')}`
        }, {}, "", {})).json();
    },

    getTransactions: async function(page = 1, pageSize = 10, searchKeyword = '', userId = '', card = '', startDate = '', endDate = '') {
        return (await api_fetch.get(`/v1/amex-transactions`, {
            Authorization: `Bearer ${storageHandler.localStorageGet('token')}`
        }, { 
            page: page, 
            pageSize: pageSize, 
            searchKeyword: searchKeyword, 
            userId: userId,
            card: card,
            startDate: startDate,
            endDate: endDate
        }, "", {})).json();
    },

    updateTransactionNotes: async function(transactionId, newNotes) {
        // Send a PUT request to the backend to update the notes
        return (await api_fetch.put(`/v1/amex-transaction-note/${transactionId}`, {
            Authorization: `Bearer ${storageHandler.localStorageGet('token')}`
        }, {}, "", { notes: newNotes })).json();
    },

    getAmexTransactionExport: async function(page = 1, pageSize = 10, keyword = '', orderBy = 'date', orderDirection = 'desc', startDate = '', endDate = '', format = 'excel') {
        // Prepare the query parameters
        const queryParams = {
            page: page,
            pageSize: pageSize,
            keyword: keyword,
            orderBy: orderBy,
            orderDirection: orderDirection,
            startDate: startDate,
            endDate: endDate,
            format: format  // Include the format parameter here
        };
    
        // Call the api_fetch.get function with the query parameters
        const response = await api_fetch.get('/v1/amex-transactions-export', {
            Authorization: `Bearer ${storageHandler.localStorageGet('token')}`
        }, queryParams, "", {});
    
        // Check if the response is an Excel file (Content-Type check)
        const contentType = response.headers.get('Content-Type');
        if (contentType && contentType === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet') {
            // If it's an Excel file, return the blob (binary data)
            return response.blob();
        } else {
            // Optionally, handle the case when the response is not an Excel file
            throw new Error("Invalid file format returned from server");
        }
    },  

    getUniqueUsers: async function() {
        return (await api_fetch.get('/v1/amex-transactions/users', {
            Authorization: `Bearer ${storageHandler.localStorageGet('token')}`
        }, {}, "", {})).json();
    },

    getUniqueCards: async function() {
        return (await api_fetch.get('/v1/amex-transactions/cards', {
            Authorization: `Bearer ${storageHandler.localStorageGet('token')}`
        }, {}, "", {})).json();
    },

    getCardFiles: async function(page = 1, pageSize = 10, keyword = '', orderBy = 'date', orderDirection = 'desc', startDate = '', endDate = '', format = 'excel') {
        // Prepare the query parameters
        const queryParams = {
            page: page,
            pageSize: pageSize,
            keyword: keyword,
            orderBy: orderBy,
            orderDirection: orderDirection,
            startDate: startDate,
            endDate: endDate,
            format: format  // Include the format parameter here
        };
    
        // Call the api_fetch.get function with the query parameters
        return (await api_fetch.get('/v1/get-card-files', {
            Authorization: `Bearer ${storageHandler.localStorageGet('token')}`
        }, queryParams, "", {})).json();
    },    

    downloadFile: async function(cardNo, fileName) {
        const fileLink = `/v1/download-file/${cardNo}/${fileName}`;
        
        // Trigger file download using the generated link
        const response = await api_fetch.get(fileLink, {
            Authorization: `Bearer ${storageHandler.localStorageGet('token')}`
        }, {}, "", {});

        if (response.ok) {
            const blob = await response.blob();
            const downloadUrl = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = downloadUrl;
            link.download = fileName; // Set the filename for download
            link.click(); // Trigger the download
        } else {
            console.error("Failed to download file");
        }
    }
};

export default amexTransactions;
